<template>
  <v-row>
    <v-col
      cols="12"
      md="4"
      class="d-print-none"
    >
      <v-card outlined>
        <v-card-text>
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr>
                  <th class="text-left">
                    Name
                  </th>
                  <td>{{ item.name }}</td>
                  <td>
                    <v-switch v-model="showName" />
                  </td>
                </tr>
                <tr>
                  <th class="text-left">
                    SKU
                  </th>
                  <td>{{ item.sku }}</td>
                  <td>
                    <v-switch v-model="showSku" />
                  </td>
                </tr>
                <tr>
                  <th class="text-left">
                    Price
                  </th>
                  <td>{{ item.price | currency }}</td>
                  <td>
                    <v-switch v-model="showPrice" />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-text>
          <v-row class="text-center">
            <v-col cols="4">
              <v-btn
                icon
                :disabled="number < 1"
                @click="number--"
              >
                <v-icon>mdi-minus-circle</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="4">
              {{ number }}
            </v-col>
            <v-col cols="4">
              <v-btn
                icon
                @click="number++"
              >
                <v-icon>mdi-plus-circle</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="symbology"
                :items="symbologies"
                label="Select Barcode Symbology"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="height"
                label="Height"
                max="750"
                type="number"
                required
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="width"
                max="750"
                label="Width"
                type="number"
                required
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      md="8"
      class="white"
    >
      <v-row class="ml-1">
        <div
          v-for="n in number"
          :key="n"
          class="pa-2 pb-0 label-border"
        >
          <div v-if="showName">
            <h6 class="mt-0 pt-0 black--text">
              {{ item.name | capitalize }}
            </h6>
          </div>
          <div class="d-flex">
            <div
              v-if="showSku"
              cols="6"
            >
              <h6 class="black--text">
                {{ item.sku | uppercase }}
              </h6>
            </div>
            <v-spacer />
            <div
              v-if="showPrice"
              cols="6"
            >
              <h6 class="black--text">
                {{ item.price | currency }}
              </h6>
            </div>
          </div>
          <img
            :src="label"
            :width="width"
            :height="height"
          >
        </div>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      symbologies: ["C39", "C39+", "C39E", "C128", "C128A"],
      label: "",
      item: {},
      symbology: "C128",
      number: 5,
      height: 60,
      width: 141,
      showName: false,
      showSku: true,
      showPrice: true,
    };
  },
  watch: {
    symbology() {
      this.getFromApi();
    },
  },
  mounted() {
    this.getFromApi();
  },
  methods: {
    getFromApi() {
      window.axios
        .post("/print-label/" + this.$route.params.id, {
          symbology: this.$data.symbology,
        })
        .then((response) => {
          this.$data.label = response.data.label;
          this.$data.item = response.data.item;
        });
    },
  },
};
</script>

<style type="text/css">
.label-border {
  border: dashed 1px red;
  border-bottom: 0px;
  border-right: 0px;
}
</style>
